// Module
var code = `<div class="auth-required-message"> <span>To view this page, please log in first - <a href="/auth">go to login</a> </span> </div> `;
// Exports
export default code;